/* unplugin-vue-components disabled */import script from "./Matrix.vue?vue&type=script&setup=true&lang=ts"
export * from "./Matrix.vue?vue&type=script&setup=true&lang=ts"

import "./Matrix.vue?vue&type=style&index=0&id=71481d15&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71481d15"]])

export default __exports__